<template>
  <div>
    <div class="DgrayBg yregister">
      <div class="w1200 flow">
        <h2>选择商品配置</h2>
        <ul>
          <li>
            <i class="step">1</i>添加清单</li>
          <li>
            <i class="step">2</i>确认订单</li>
          <li>
            <i>3</i>在线支付</li>
          <li>
            <i>4</i>支付成功</li>
        </ul>
      </div>
    </div>
    <div class="trademark-success">
      <div class="success-panel w1200 auto pt100">
        <div class="tc ">
          <span style="color:#525252;">需求类型：</span><span style="color:#1fb09f;">{{$route.query.buyVersion=='1'?'担保注册版':$route.query.buyVersion=='2'?'商标续展':'专家辅导版'}}</span>&nbsp;&nbsp;&nbsp;
          <span style="color:#525252;">预期价格：</span><span style="color:#999999;">2000元以下</span>
        </div>
        <div class="tc"
             style="margin-top:45px;margin-bottom: 40px;">
          <img src="../static/assets/apply-success-icon.png"
               alt="">
        </div>
        <p class="tc f18"
           style="color:#333333;">您的{{$route.query.buyVersion=='1'?'担保注册版':$route.query.buyVersion=='2'?'商标续展':'专家辅导版'}}需求发布成功！</p>
        <p class="tc f12 mt10"
           style="color:#999;">1-2个工作日内服务商会与您联络，请保持电话畅通</p>
        <div class="
         tc"
             style="margin-top: 32px;">
          <a class="i-know"
             href="/trademark">知道了</a>
        </div>

        <div style=""
             class="auto success-tip">
          <div style="padding:36px;">
            <p style="color:#666666;"
               class="f14">服务商后续注册流程需要您提供以下资料，请提前准备。</p>
            <p class="f12"
               style="color:#999999;margin-top:25px;"><span style="color:#666666;">个人：</span>申请人身份证正反面照片、个体工商户营业执照照片、委托书、委托书模板复用法律声明</p>
            <p class="f12"
               style="color:#999999;margin-top:13px;"><span style="color:#666666;">企业：</span>申请企业营业执照副本复印件、委托书、委托书模板复用法律声明</p>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {

}
</script>

<style lang="scss">
.trademark-success {
  // position: absolute;
  // top: 90px;
  // height: 745px;
  // right: 0;
  // left: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  background: #f2f2f2;

  .pt100 {
    padding-top: 100px;
  }

  .success-panel {
    padding-bottom: 57px;
    background: #fff;
  }

  .i-know {
    display: inline-block;
    padding: 12px 22px;
    color: #fff;
    background: #1fb09f;
    border-radius: 3px;
    margin-bottom: 40px;
  }

  .success-tip {
    background: #f8f8f8;
    width: 950px;
    margin-bottom: 58px;
  }
}
</style>



// WEBPACK FOOTER //
// src/trademarksuccess.vue